import { useState } from 'react';
import SpellSlot from '../../components/dnd/spells/SpellSlot';
import Frame from '../../components/dnd/frame/Frame';

export type SpellSlotLevel = {
    level: number;
    total: number;
    spent: number;
};

function SpellSlots({ className, spellSlots }: { className?: string; spellSlots: SpellSlotLevel[] }) {
    const [slots, setSlots] = useState<SpellSlotLevel[]>(spellSlots);

    return (
        <Frame
            title="Spell Slots"
            styleInner={{
                columnWidth: 100 + 40 * Math.max(...slots.map(slot => slot.total)),    // 100px + 40px per slot
            }}
            className={className}
        >
            {slots.map((slotLevel) => {
                return (
                    <SpellSlot
                        key={slotLevel.level}
                        name={`Level ${slotLevel.level}`}
                        total={slotLevel.total}
                        spent={slotLevel.spent}
                        onChange={(spent) => {
                            setSlots((prevSlots) =>
                                prevSlots.map((slot) =>
                                    slot.level === slotLevel.level
                                        ? { ...slot, spent }
                                        : slot,
                                ),
                            );
                        }}
                    />
                );
            })}
        </Frame>
    );
}

export default SpellSlots;